<template>
  <b-container id="software" class="mb-5">
    <h2>{{ msg }}</h2>
    <b-row class="justify-content-md-center">
      <b-col md="10" class="text-center mt-3">
      <p>
        The system uses the Convolutional Neural Network (CNN) architecture. CNN network consists of different layers that process the input alphabets and symbols and produce the desired output. We are working on creating a model that can help society in a broader way by bridging the communication gap between normal people and muted people. We propose a system, acting as an interface between the Deaf-dumb community and normal people based on American Sign Language (ASL). The speech Conversion system helps in decoding those symbols without the need of an expert person who understands the sign language. 
      </p>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col col lg="">
        <img alt="covid banner" src="../assets/Project_Diagram-Page.svg">
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Software achitecture',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
a {
  color: #42b983;
}
</style>
